module.exports = __webpack_public_path__ + "img/d-menu-user-star-donors.dcf45c76.svg";